import { render, staticRenderFns } from "./AdministrativeRegion.vue?vue&type=template&id=46f1c575&"
import script from "./AdministrativeRegion.vue?vue&type=script&lang=js&"
export * from "./AdministrativeRegion.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeRegion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports